import api from './api';

export const alertService = {
  // Alert CRUD
  getAlerts: () => api?.get('/alerts'),
  createAlert: (data) => api?.post('/alerts', data),
  updateAlert: (id, data) => api?.put(`/alerts/${id}`, data),
  deleteAlert: (id) => api?.delete(`/alerts/${id}`),
  testAlert: (id) => api?.post(`/alerts/${id}/test`),

  // Notifications
  getNotifications: (params) => api?.get('/notifications', { params }),
  markRead: (id) => api?.put(`/notifications/${id}/read`),
  markAllRead: () => api?.put('/notifications/read-all'),
  dismissNotification: (id) => api?.delete(`/notifications/${id}`),
  dismissAll: () => api?.delete('/notifications/dismiss-all'),

  // Monitor
  runMonitor: () => api?.post('/alerts/monitor/run'),
  getMonitorStatus: () => api?.get('/alerts/monitor/status'),
};

export default alertService;
